export type DomainSurface = 'app' | 'product' | 'public-site';

const PRODUCT_HOSTS = new Set(['carlotpilot.com', 'www.carlotpilot.com']);
const APP_SUBDOMAIN_PREFIXES = ['staging.', 'dev.', 'app.', 'crm.'];
const APP_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export const getDomainSurface = (hostname: string): DomainSurface => {
  const normalizedHostname = hostname.trim().toLowerCase();

  if (PRODUCT_HOSTS.has(normalizedHostname)) {
    return 'product';
  }

  if (
    APP_HOSTS.has(normalizedHostname) ||
    APP_SUBDOMAIN_PREFIXES.some((prefix) => normalizedHostname.startsWith(prefix))
  ) {
    return 'app';
  }

  return 'public-site';
};
